import { StorageKey } from '~constants/Constants';
import { ConfigRepository } from '~repositories/ConfigRepository';
import { UserRepository } from '~repositories/UserRepository';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';
import { removeLocalStorageItems } from '~utils/LocalStorageUtils';

import { IamType } from '../../constants/Constants';
import { UserStateResolverService } from '../services/UserStateResolverService';

export class UpdateUserIfNeededAfterSignInUseCase {
    private userRepository: UserRepository;
    private configRepository: ConfigRepository;

    private userId?: number;
    private isSignInAfterSignUp?: boolean;

    constructor(userId?: number, isSignInAfterSignUp?: boolean) {
        this.userId = userId;
        this.userRepository = diContainer.get(serviceNames.userRepository);
        this.configRepository = diContainer.get(serviceNames.configRepository);
        this.isSignInAfterSignUp = isSignInAfterSignUp;
    }

    public execute = async () => {
        const { userId, isSignInAfterSignUp } = this;
        if (userId && !isSignInAfterSignUp) {
            const {
                isSignInToConnect,
                consentForm: { formValuesBackup },
                userProfileChanges,
                updateUser
            } = this.userRepository;

            let formValues = null;
            // Social sign in to connect
            if (isSignInToConnect) {
                formValues = formValuesBackup;
            } else if (this.isMatchedWithExistingUser(userId)) {
                formValues = userProfileChanges;
            }
            if (formValues) {
                await updateUser(userId, formValues);
            }
        }
        removeLocalStorageItems([StorageKey.CONNECT_USER_ID, StorageKey.FORM_VALUES]);
    };

    // In store sign up existing user redirect to sign in page,
    // need store form values and update user after sign in / login
    private isMatchedWithExistingUser = (userId: number) => {
        if (this.configRepository.iamType !== IamType.IN_STORE) {
            return false;
        }

        const existingUsers = this.userRepository.matchedExistingUsers;

        if (!existingUsers || existingUsers.length === 0) {
            return false;
        }

        const { completeUserIds } = new UserStateResolverService(existingUsers);

        return completeUserIds.includes(userId);
    };
}
